var _path, _path2, _path3, _path4, _circle, _circle2, _rect, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNofunding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 35,
    viewBox: "0 0 37 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1185 7.96767C19.4337 7.93712 19.7487 8.02897 19.998 8.22432L24.6983 11.9079C24.9637 12.116 25.1323 12.4237 25.1648 12.7594L26.9529 31.2123C27.0186 31.89 26.5224 32.4927 25.8447 32.5584L6.75506 34.4081C6.07734 34.4738 5.47469 33.9776 5.40902 33.2998L3.22361 10.7465C3.15795 10.0688 3.65415 9.46609 4.33186 9.40042L19.1185 7.96767ZM19.1977 8.78578L4.41113 10.2185C4.18522 10.2404 4.01982 10.4413 4.04171 10.6672L6.22712 33.2206C6.24901 33.4465 6.44989 33.6119 6.6758 33.59L25.7654 31.7403C25.9913 31.7184 26.1567 31.5175 26.1348 31.2916L24.3467 12.8386C24.3359 12.7267 24.2797 12.6242 24.1912 12.5549L19.4909 8.87126C19.4078 8.80615 19.3028 8.7756 19.1977 8.78578Z",
    fill: "#4A304A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30641 12.4778C5.25314 11.928 5.65559 11.4392 6.2053 11.386L18.4556 10.1989C18.7113 10.1741 18.9667 10.2487 19.1689 10.4071L23.001 13.4103C23.2163 13.5791 23.3531 13.8287 23.3795 14.101L24.8699 29.4826C24.9232 30.0323 24.5208 30.5211 23.9711 30.5743L8.2126 32.1014C7.66289 32.1546 7.17408 31.7522 7.12081 31.2025L5.30641 12.4778Z",
    fill: "#B7ACB7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4713 29.2392H32.9784C33.4323 29.2392 33.8003 28.8712 33.8003 28.4172V8.96444C33.8003 8.75058 33.717 8.54514 33.568 8.39174L29.1396 3.83301H14.4713C14.0174 3.83301 13.6494 4.201 13.6494 4.65493V28.4172C13.6494 28.8712 14.0174 29.2392 14.4713 29.2392Z",
    fill: "#B7ACB7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2373 4.65574C13.2373 3.97483 13.7893 3.42285 14.4702 3.42285H29.3122L33.8616 8.10617C34.0851 8.33627 34.2101 8.64444 34.2101 8.96522V28.4181C34.2101 29.099 33.6581 29.651 32.9773 29.651H14.4702C13.7893 29.651 13.2373 29.099 13.2373 28.4181V4.65574ZM14.0592 28.4181C14.0592 28.645 14.2432 28.8291 14.4702 28.8291H32.9773C33.2042 28.8291 33.3882 28.645 33.3882 28.4181V8.96522C33.3882 8.8583 33.3465 8.75557 33.272 8.67887L29.5493 4.84657V7.9926C29.5493 8.21954 29.7334 8.40352 29.9603 8.40356H32.2914C32.5183 8.40359 32.7023 8.58758 32.7023 8.81452C32.7023 9.04147 32.5183 9.22545 32.2914 9.22549H29.9603C29.2794 9.22545 28.7274 8.67348 28.7274 7.9926V4.24478H14.4702C14.2432 4.24478 14.0592 4.42877 14.0592 4.65574V28.4181Z",
    fill: "#4A304A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.6525,
    cy: 18.1106,
    r: 4.68477,
    fill: "#B7ACB7",
    stroke: "#4A304A",
    strokeWidth: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.6524,
    cy: 18.1114,
    r: 6.47175,
    stroke: "#4A304A",
    strokeWidth: 0.8
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30.959,
    y: 24.3877,
    width: 1.88359,
    height: 5.98879,
    rx: 0.941794,
    transform: "rotate(-45 30.959 24.3877)",
    fill: "#4A304A",
    stroke: "#4A304A",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3906 22.6084L31.5256 23.7434",
    stroke: "#4A304A",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7627 16.1865L23.885 20.0642",
    stroke: "#4A304A",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8857 16.1855L27.7634 20.0632",
    stroke: "#4A304A",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNofunding);
export default __webpack_public_path__ + "static/media/nofunding.a48b713929e2d6410bf9521d9aa27ed2.svg";
export { ForwardRef as ReactComponent };